import React from "react";

import { LabUIToolbox as Value } from "@reactivated";

import { AlignedRichTextBlock } from "../AlignedRichTextBlock";
import { LinkBlock } from "../LinkBlock";
import { clickableMap } from "../LinkSubBlock";
import { MediaChooserBlock } from "../MediaChooserBlock";
import {
    ScrollNavMenuBlock,
    ScrollNavMenuItemBlock,
} from "../ScrollNavMenuBlock";
import { SocialMediaIcon } from "../SocialMediaIcon";
import { SpacerBlock } from "../SpacerBlock";
import { StreamField, StreamFieldBlockMap } from "../StreamField";
import { TableInContainerBlock } from "../TableInContainerBlock";
import { VideoChooserBlock } from "../VideoChooserBlock";

interface Props {
    value: Value;
    components?: Partial<StreamFieldBlockMap<Value>>;
    tagName?: keyof React.ReactHTML | typeof React.Fragment;
    attrs?: React.HTMLAttributes<HTMLElement>;
}

export const defaultComponents: StreamFieldBlockMap<Value> = {
    alignedrichtextblock: AlignedRichTextBlock,
    gallerysubblock: () => null,
    linksubblock: (args) => <LinkBlock {...args} clickableMap={clickableMap} />,
    mediachooserblock: MediaChooserBlock,
    scrollnavmenublock: ScrollNavMenuBlock,
    scrollnavmenuitemblock: ScrollNavMenuItemBlock,
    socialmediaicon: SocialMediaIcon,
    spacerblock: SpacerBlock,
    tableincontainerblock: TableInContainerBlock,
    videochooserblock: VideoChooserBlock,
};

export const LabUIToolbox = (props: Props) => {
    return (
        <StreamField
            components={{
                ...defaultComponents,
                ...props.components,
            }}
            value={props.value}
            tagName={props.tagName}
            attrs={props.attrs}
        />
    );
};
